module.exports = __webpack_public_path__ + "static/media/perfil.54afa65d.jpeg";